export default "__VITE_ASSET__0dd24773__$_?nuxt_component=async__"